module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report"
  }, [_c('header', [_vm._m(0), _vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "reportbox",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "J_ReportBox"
    }
  }, [_c('div', {
    staticClass: "reporttop"
  }, [_c('div', {
    staticClass: "person"
  }, [_c('span', {
    staticClass: "place"
  }, [_vm._v(_vm._s(_vm.reportResult.nation))]), _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.reportResult.patientName))]), _c('span', {
    staticClass: "sex"
  }, [_vm._v(_vm._s(_vm.reportResult.sex))]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportResult.age !== ''),
      expression: "reportResult.age !== ''"
    }],
    staticClass: "age"
  }, [_vm._v(_vm._s(_vm.reportResult.age) + "岁")])]), _vm._v(" "), _c('div', {
    staticClass: "medicaldoctor"
  }, [_c('span', [_vm._v("体检医生：")]), _c('em', [_vm._v(_vm._s(_vm.reportResult.doctorName))])]), _vm._v(" "), _c('div', {
    staticClass: "medicaltime"
  }, [_c('span', [_vm._v("体检日期：")]), _c('em', [_vm._v(_vm._s(_vm.reportResult.examTime))])]), _vm._v(" "), _c('div', {
    staticClass: "personphone"
  }, [_c('span', [_vm._v("手机号码：")]), _c('em', [_vm._v(_vm._s(_vm.reportResult.tel))])])]), _vm._v(" "), _c('div', {
    staticClass: "reportcenter"
  }, _vm._l((_vm.reportResult.report), function(item) {
    return _c('div', {
      staticClass: "reportdetaile"
    }, [_c('h4', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), (item.itemValue.hasImage) ? _c('div', {
      staticClass: "imgbox"
    }, [_c('span', {
      staticClass: "small-imgbox J_ScaleImg",
      attrs: {
        "data-size": item.itemValue.imageSize[0],
        "data-src": item.itemValue.image[0]
      }
    }, [_c('img', {
      attrs: {
        "src": item.itemValue.image[0]
      }
    })])]) : _vm._e(), _vm._v(" "), (item.itemValue.hasTeeth) ? _c('div', _vm._l((item.itemValue.teeth), function(item) {
      return _c('div', {
        staticClass: "ten-con"
      }, [_c('span', {
        staticClass: "tentitle"
      }, [_c('p', {
        staticClass: "small-tit"
      }, [_vm._v(_vm._s(item.name))]), _c('br')]), _vm._v(" "), _c('div', {
        staticClass: "tenimg"
      }, [_c('div', {
        staticClass: "img_center ten-img-center",
        attrs: {
          "id": "J_Toothfour"
        }
      }, [_c('span', {
        staticClass: "horizontal-line"
      }), _vm._v(" "), _c('span', {
        staticClass: "vertical-line"
      }), _vm._v(" "), _c('span', {
        staticClass: "select-area top-left J_SelectArea0"
      }, [_vm._v(_vm._s(item.data.t_r))]), _vm._v(" "), _c('span', {
        staticClass: "select-area top-right J_SelectArea1"
      }, [_vm._v(_vm._s(item.data.t_l))]), _vm._v(" "), _c('span', {
        staticClass: "select-area bottom-left J_SelectArea2"
      }, [_vm._v(_vm._s(item.data.b_r))]), _vm._v(" "), _c('span', {
        staticClass: "select-area bottom-right J_SelectArea3"
      }, [_vm._v(_vm._s(item.data.b_l))])])])])
    })) : _vm._e(), _vm._v(" "), _vm._l((item.itemValue.other), function(item) {
      return _c('div', [_c('p', {
        staticClass: "context"
      }, [_vm._v(_vm._s(item))])])
    })], 2)
  }))]), _vm._v(" "), _c('div', {
    staticClass: "error-tip",
    attrs: {
      "id": "J_ErrorTip"
    }
  }), _vm._v(" "), _c('MenuFooters', {
    attrs: {
      "isHide": _vm.isHide,
      "menuType": _vm.currentMenuType
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "back",
    attrs: {
      "href": "/#/my"
    }
  }, [_c('div', {
    staticClass: "arrow-left"
  }, [_c('div', {
    staticClass: "arrow"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "J_Loading"
    }
  }, [_c('img', {
    staticClass: "loading-img",
    attrs: {
      "src": require("../assets/loading.gif")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-919d2d56"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Report.vue
// module id = 201
// module chunks = 1